import { Helmet } from 'react-helmet-async'

interface PageMetaProps {
  title: string
  description: string
  canonical?: string
  ogImage?: string
}

const BASE_URL = 'https://www.contractfinderpro.com'
const DEFAULT_OG_IMAGE = `${BASE_URL}/og-image.png`

export default function PageMeta({ title, description, canonical, ogImage }: PageMetaProps) {
  const fullTitle = title.includes('Contract Finder Pro')
    ? title
    : `${title} | Contract Finder Pro`
  const canonicalUrl = canonical ? `${BASE_URL}${canonical}` : undefined

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage ?? DEFAULT_OG_IMAGE} />
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}
      <meta property="og:site_name" content="Contract Finder Pro" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage ?? DEFAULT_OG_IMAGE} />
    </Helmet>
  )
}
